var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { List, Input, Empty, Dropdown, Menu, Button, Tag } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
var Search = Input.Search;
var extractNumberFromContent = function (content) {
    var _a;
    if (typeof content === "number")
        return content.toString();
    if (typeof content === "string")
        return content;
    if (React.isValidElement(content)) {
        var children = (_a = content.props) === null || _a === void 0 ? void 0 : _a.children;
        if (children) {
            if (typeof children === "string") {
                var match = children.match(/(\d+)/);
                return match ? match[1] : "0";
            }
            if (typeof children === "number") {
                return children.toString();
            }
        }
    }
    return "0";
};
var CompsList = function (_a) {
    var _b = _a.listData, listData = _b === void 0 ? [] : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, onSelect = _a.onSelect, _d = _a.showSearch, showSearch = _d === void 0 ? true : _d, selectedId = _a.selectedId, _e = _a.menuItems, menuItems = _e === void 0 ? [] : _e, onMenuClick = _a.onMenuClick, _f = _a.height, height = _f === void 0 ? "100%" : _f, style = _a.style, className = _a.className, _g = _a.searchPlaceholder, searchPlaceholder = _g === void 0 ? "搜索..." : _g, _h = _a.defaultSearchValue, defaultSearchValue = _h === void 0 ? "" : _h, _j = _a.draggable, draggable = _j === void 0 ? false : _j, onDragStart = _a.onDragStart, onReorder = _a.onReorder;
    var _k = useState(defaultSearchValue), searchValue = _k[0], setSearchValue = _k[1];
    var _l = useState(null), draggingId = _l[0], setDraggingId = _l[1];
    var filteredListData = useMemo(function () {
        if (!searchValue)
            return listData;
        var lower = searchValue.toLowerCase();
        return listData.filter(function (item) {
            return (item.leftContent || "").toLowerCase().includes(lower);
        });
    }, [listData, searchValue]);
    useEffect(function () {
        // 当上游 listData 变化时，保持当前搜索逻辑
    }, [listData]);
    var renderItemMenu = function (item) {
        if (!onMenuClick || !menuItems.length)
            return null;
        var menu = (_jsx(Menu, __assign({ onClick: function (_a) {
                var key = _a.key;
                onMenuClick && onMenuClick(item, key);
            } }, { children: menuItems.map(function (menuItem) { return (_jsx(Menu.Item, { children: menuItem.label }, menuItem.key)); }) })));
        return (_jsx(Dropdown, __assign({ overlay: menu, trigger: ["click"] }, { children: _jsx(Button, { type: "text", icon: _jsx(EllipsisOutlined, {}), size: "small", onClick: function (e) {
                    e.stopPropagation();
                }, style: {
                    marginLeft: "auto",
                    padding: "0 5px",
                    color: "#bfbfbf",
                }, className: "list-item-menu-button" }) })));
    };
    return (_jsxs("div", __assign({ className: className, style: __assign({ height: typeof height === "number" ? "".concat(height, "px") : height, display: "flex", flexDirection: "column", minHeight: 0 }, style) }, { children: [showSearch && (_jsx(Search, { placeholder: searchPlaceholder, allowClear: true, value: searchValue, onChange: function (e) { return setSearchValue(e.target.value); }, style: { marginBottom: 16 } })), _jsx("div", __assign({ style: {
                    flex: 1,
                    minHeight: 0,
                    overflow: "auto",
                } }, { children: filteredListData.length > 0 ? (_jsx(List, { className: "comps-list", dataSource: filteredListData, loading: loading, renderItem: function (item) { return (_jsx(List.Item, __assign({ onClick: function () {
                            onSelect && onSelect(item);
                        }, draggable: draggable, onDragStart: function (e) {
                            if (draggable && onDragStart) {
                                setDraggingId(item.id);
                                onDragStart(item, e);
                            }
                            else if (draggable) {
                                // 默认处理：将数据存储到 dataTransfer
                                setDraggingId(item.id);
                                e.dataTransfer.setData("text/plain", item.id);
                                e.dataTransfer.effectAllowed = "move";
                            }
                        }, onDragOver: function (e) {
                            if (!draggable)
                                return;
                            // 仅在未开启搜索时允许拖拽排序，避免过滤列表导致索引错乱
                            if (searchValue)
                                return;
                            e.preventDefault();
                        }, onDrop: function (e) {
                            if (!draggable || !onReorder)
                                return;
                            if (searchValue)
                                return;
                            e.preventDefault();
                            var sourceId = draggingId || e.dataTransfer.getData("text/plain");
                            if (!sourceId || sourceId === item.id)
                                return;
                            var sourceIndex = listData.findIndex(function (it) { return it.id === sourceId; });
                            var targetIndex = listData.findIndex(function (it) { return it.id === item.id; });
                            if (sourceIndex === -1 || targetIndex === -1)
                                return;
                            var newList = __spreadArray([], listData, true);
                            var moved = newList.splice(sourceIndex, 1)[0];
                            newList.splice(targetIndex, 0, moved);
                            onReorder(newList);
                            setDraggingId(null);
                        }, style: {
                            cursor: draggable ? "grab" : onSelect ? "pointer" : "default",
                            backgroundColor: selectedId === item.id ? "#f0f7ff" : "transparent",
                            padding: "8px",
                            borderRadius: "4px",
                            transition: "background-color 0.3s",
                        }, className: "comps-list-item" }, { children: _jsxs("div", __assign({ style: {
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                            } }, { children: [_jsxs("div", __assign({ style: {
                                        display: "flex",
                                        alignItems: "center",
                                        fontWeight: selectedId === item.id ? 500 : 400,
                                        justifyContent: "space-between",
                                        width: "100%",
                                    } }, { children: [_jsx("span", __assign({ style: { marginRight: "8px" } }, { children: item.leftContent })), item.rightContent && (_jsx(_Fragment, { children: React.isValidElement(item.rightContent) ? (item.rightContent) : (function () {
                                                var extractedNumber = extractNumberFromContent(item.rightContent);
                                                var isNumber = typeof item.rightContent === "number" ||
                                                    (typeof item.rightContent === "string" && /^\d+$/.test(item.rightContent)) ||
                                                    (extractedNumber !== "0" && extractedNumber !== "");
                                                if (isNumber) {
                                                    return (_jsx(Tag, __assign({ color: "blue", style: { marginInlineEnd: 0 } }, { children: extractedNumber })));
                                                }
                                                else {
                                                    return item.rightContent;
                                                }
                                            })() }))] })), renderItemMenu(item)] })) }), item.id)); } })) : (_jsx(Empty, { description: "\u6682\u65E0\u6570\u636E" })) }))] })));
};
export default CompsList;
